import { useState } from 'react';
import MockAutocomplete from '../../../MockAutocomplete';
import VtexInput from '../../../styleguide/VtexInput';
import { useSearchBar } from '../hooks/useSearchBar';
import SearchBarIcon from './SearchBarIcon';
import SuffixWrapper from './SuffixWrapper';

const AutoCompleteOuterContainer = () => {
	const { blockClass, placeholder } = useSearchBar();
	const [inputValue, setInputValue] = useState('');

	return (
		<>
			<div
				className={`autoCompleteOuterContainer autoCompleteOuterContainer--${blockClass} vtex-store-components-3-x-autoCompleteOuterContainer vtex-store-components-3-x-autoCompleteOuterContainer--${blockClass}`}
			>
				<div className="w-100 flex">
					<VtexInput
						onChange={(e: any) => setInputValue(e.target.value)}
						placeholder={placeholder}
						suffix={
							<SuffixWrapper>
								<SearchBarIcon />
							</SuffixWrapper>
						}
					/>
				</div>
			</div>
			<MockAutocomplete blockClass={blockClass} showAutocomplete={!!inputValue} inputValue={inputValue} />
		</>
	);
};

export default AutoCompleteOuterContainer;
